import { Icon, ResponsiveImage } from '@sleepstation/components'
import { CopyParagraph } from '@sleepstation/components-copy'
import { HLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import {
  backgroundColor,
  borderRadius,
  color,
  padding,
  mq,
} from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(HLayout).attrs({
  align: LAYOUT_ALIGN.CENTER,
  spacing: LAYOUT_SPACING.MEDIUM,
})`
  ${borderRadius(1.25)}
  ${padding([
    [0.5, 0.75],
    [0.5, 0.75],
    [0.55, 0.75],
  ])}
  ${backgroundColor(`primaryBackground`)}
  align-self: center;
  max-width: 500px;
`

const IconWrapper = styled.div`
  ${color(`primaryIcon`)}
`

const ImageWrapper = styled.div`
  width: 50px;

  ${mq(`mediumUp`)} {
    width: 63px;
  }
`

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const InfoPill = ({ title, iconName, image }) => (
  <Layout>
    {iconName && (
      <IconWrapper>
        <Icon name={iconName} />
      </IconWrapper>
    )}
    {image && (
      <ImageWrapper>
        <ResponsiveImage
          aspectRatio={image.aspectRatio}
          src={image.url}
          alt={image.alt}
        />
      </ImageWrapper>
    )}
    <CopyParagraph>{title}</CopyParagraph>
  </Layout>
)

InfoPill.propTypes = {
  title: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  image: PropTypes.object,
}

InfoPill.defaultProps = {
  iconName: null,
  image: null,
}

export default InfoPill
